<template>
	<div>
	<mt-popup class="policy"
			  v-model="showTerms"
			  position="bottom">
		<div class="policy-pop">
			<div class="policy-header">用户协议及隐私政策</div>
			<div class="policy-content">
				<div class="info login-info">
					<div class="inner-info">
						<div class="info-wrap">
							<p><br>在您注册成为顺丰速运会员的过程中，您需要通过点击同意的形式在线签署<span style="font-weight:bold">《顺丰速运用户协议》、《顺丰速运隐私政策》</span>，请您务必仔细阅读、充分理解条款内容后再点击同意（尤其是以粗体并下划线标识的条款，因为这些条款可能会明确您应履行的义务或对您的权利有所限制）。<br><br></p>
						</div>
						<div class="info-wrap">
							<p class="info-name">请您注意：如果您不同意上述服务条款、隐私政策或其中任何约定，请您停止注册。如您阅读并点击同意即表示您已充分阅读、理解并接受其全部内容，并表明您也同意顺丰速运可以依据以上隐私政策来处理您的个人信息。如您对以上服务条款、隐私政策有任何疑问，您可联系顺丰速运客服。<br><br></p>
						</div>
					</div>
				</div>
			</div>
			<div class="policy-footer">
				<div class="tip-content">
					点击同意即代表您已阅读并同意<i @click="openSfTerm('server')">《顺丰速运用户协议》</i>、<a :href="privaryPolicyUrl">《顺丰速运隐私政策》</a>。
				</div>
				<div class="confirm-btn">
					<div class="btn btn-cancel" @click="confirm(false)">不同意</div>
					<div class="btn btn-agree" @click="confirm(true)">同意</div>
				</div>
			</div>
		</div>
	</mt-popup>
	<div class="detail-info" v-if="isShowDetail">
		<div class="title">
			<i class="detail-close" @click="isShowDetail = false"></i>
                {{ serviceClauseTitle }}
		</div>
        <ckeditor-content v-if="type === 'privacy' && privavcyContent" class="content" :content="privavcyContent"></ckeditor-content>
		<div v-else class="content">
			<div>
				<div v-html="serviceClauseHtml"></div>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
	import policyText from "./terms"
    import ajax from "@/api/ajax";
    import ckeditorContent from '@/components/ckeditor-content'
	import { urls } from "@/constant/paths/"
	export default {
		data(){
			return{
				showTerms:false,
				termsInfo:'',
				isShowDetail:false,
                type: '',
                privavcyContent: '',
				privaryPolicyUrl:urls.PRIVARY_POLICY,
				serviceClauseHtml: null,
				serviceClauseTitle: ''
			}
		},
        components: {
            ckeditorContent
        },
		methods: {
			show(){
				this.showTerms = true;
			},
			// 是否同意协议
			confirm(b) {
				this.showTerms = false;
				this.$emit('confirm', b);
			},

			//打开顺丰速运条款
			openSfTerm(type){
                this.type = type
                if(type === 'privacy') {
                    ajax.getPrivacyPolicy().then((res) => {
                        this.privavcyContent = res.content
                    })
                }
				this.isShowDetail = true;
				const params = {
					'filters[type][$eq]': 'serviceClause'
				}
				ajax.queryContract({ params }).then((res) => {
					if(res && res.length > 0){
						this.serviceClauseTitle = res[0].title
						this.serviceClauseHtml = res[0].content
					}
				})
			},
		}
	}
</script>

<style scoped>
	.policy{
		width:100%;
		/*box-shadow:0 1px 20px 10px rgba(0,0,0,.1)*/
	}
	.policy-header{
		text-align: center;
		font-size:36px;
		font-weight: bold;
		height:100px;
		line-height:100px;
		border-bottom:.1px solid #f2f2f2
	}
	.policy-content{
		padding:0 60px;
		height:600px;
		overflow-y:scroll;
	}
	.policy-footer{
		/*padding:0 70px;*/
	}
	.tip-content{
		padding:30px 70px 100px 70px;
	}
	.tip-content i,.tip-content a{
		font-style:normal;
		color:#007aff;
	}
	.confirm-btn{
		margin-top:20px;
		display:flex;
		border-top:20px solid #f2f2f2
	}
	.confirm-btn .btn{
		height:100px;
		line-height:100px;
		flex:1;
		text-align: center;
	}
	.confirm-btn .btn-cancel{
		border-right:1px solid #ccc;
	}
	.confirm-btn .btn-agree{
		color:#dc1e32;
	}
	.detail-close{
		position:absolute;
		top:40px;
		left:50px;
	}

	.detail-close:before{
		content: "";
		display: block;
		position: absolute;
		width: 40px;
		height: 4px;
		background: #000;
		z-index: 9;
		transform-origin:2px 5px;
	}
	.detail-close:after{
		content: "";
		display: block;
		position: absolute;
		width: 24px;
		height: 24px;
		border-left: 4px solid #000;
		border-top:4px solid #000;
		background:transparent;
		z-index: -1;
		transform: rotate(-45deg);
		top:-12px;
		left:3px;
	}
	.detail-info{
		position: fixed;
		top:0;
		left:0;
		bottom:0;
		z-index: 3000;
		width:100%;
		background-color: white;
		font-size:24px;
	}
	.detail-info .title{
		font-size:40px;
		text-align: center;
		height:100px;
		line-height: 100px;
		border-bottom:1px solid #f2f2f2;
	}
	.detail-info .content{
		height:100%;
		overflow-y: scroll;
		padding:40px 80px 160px 80px;
		line-height:42px;
	}
</style>



// WEBPACK FOOTER //
// src/components/protocal/index.vue